/*----------------------------------
- MENU SHARED HELPERS
----------------------------------*/

import type {
    LandingHeaderDomainsNavItem,
    LandingHeaderNavPanelItem,
} from '@/client/catalogs/landing/pageContent';
import { formatCompactStat } from '@/client/pages/landing/lib/formatCompactStat';

/*----------------------------------
- HELPERS
----------------------------------*/

export const getDomainsMenuColumnItems = (
    menu: LandingHeaderDomainsNavItem,
    title: string,
): readonly LandingHeaderNavPanelItem[] => menu.columns.find((column) => column.title === title)?.items || [];

/** Counts are optional producer data: anything that is not a real non-negative number renders nothing. */
export const readMenuItemCount = (menuItem: LandingHeaderNavPanelItem): string | null => {
    if (typeof menuItem.count !== 'number' || !Number.isFinite(menuItem.count) || menuItem.count < 0) return null;
    return formatCompactStat(menuItem.count);
};

/** The payload sends bare extensions (`ai`), and the menu reads them as endings (`.ai`). */
export const formatTldLabel = (extension: string): string =>
    extension.startsWith('.') ? extension : `.${extension}`;
